const Record = () => import('@/views/main/consumer/record/Record.vue')
export default {
  path: '/main/consumer/record',
  name: 'ConsumerRecord',
  component: Record,
  children: []
}
